import * as graphql from 'generated/graphql';

export type LibraryCategoryMutations<T> = {
	createCategory?: (name: graphql.LocalizedString) => Promise<T>;
	reorderCategory?: (id: string, order: number) => Promise<T>;
};

export type LibraryItemMutations<U> = {
	reorderItem?: (id: string, categoryID: string, order: number) => Promise<U>;
};

export type LibraryMutations<T, U> = LibraryCategoryMutations<T> & LibraryItemMutations<U>;
